import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import "survey-core/defaultV2.min.css";
import "../css/index.css";
import axios from "axios";
import Swal from "sweetalert2";
import DashNavbar from "../Misc/DashNavbar";
import Sidebar from "../Misc/Sidebar";
import ProgressBar from "react-bootstrap/ProgressBar";
import { Spinner } from "react-bootstrap";

function getColor(progress) {
  if (progress >= 0 && progress < 25) {
    return "danger";
  } else if (progress >= 25 && progress < 50) {
    return "warning";
  } else if (progress >= 50 && progress < 75) {
    return "primary";
  } else {
    return "success";
  }
}

function preventNonNumericInput(event) {
  if (
    !/[0-9]/.test(event.key) &&
    event.key !== "Backspace" &&
    event.key !== "Delete" &&
    event.key !== "ArrowLeft" &&
    event.key !== "ArrowRight" &&
    event.key !== "Tab"
  ) {
    event.preventDefault();
  }
}

function calculateAge(dateOfBirth) {
  if (!dateOfBirth) return "";
  const dob = new Date(dateOfBirth);
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age--;
  }
  return age.toString();
}

function Jobapplication(props) {
  const [resumeFile, setResumeFile] = useState(null);
  const [resumePath, setResumePath] = useState("");
  const [formData, setFormData] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    phone: "",
    email: "",
    gender: "",
    date_of_birth: "",
    age: "",
    marital_status: "",
    referred_by: "",
    referred_contact: "",
    acknowledged: false,
    address_type: "",
    country: "",
    state: "",
    district: "",
    tehsil: "",
    village: "",
    zip_code: "",
    education: "",
    degree: "",
    experience: "",
    Work_total_experience_months: "",
    Work_total_experience_year: "",
    current_comapny_name: "",
    current_company_address: "",
    job_title: "",
    current_ctc: "",
    gross: "",
    net: "",
    variables: "",
    current_notice_period_days: "",
    reason_for_leaving: "",
    resume: "",
  });

  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [surveyModel, setSurveyModel] = useState(null);

  const TOTAL_FIELDS_FOR_PROGRESS = 33;

  useEffect(() => {
    const userEmail = localStorage.getItem("email");
    if (userEmail) {
      setFormData((prevState) => ({ ...prevState, email: userEmail }));
      fetchData();
    }
  }, []);

  async function fetchData() {
    try {
      const userId = localStorage.getItem("user_id");
      if (!userId) return;

      const response = await axios.get("https://raasbackend.vetrinahealthcare.com/api/applicants/");
      
      const allApplicants = response.data;
      const currentApplicant = Array.isArray(allApplicants) 
        ? allApplicants.find(app => String(app.user) === String(userId))
        : allApplicants;

      if (currentApplicant) {
        const updatedFormData = { ...formData };
        for (const key in currentApplicant) {
          if (Object.prototype.hasOwnProperty.call(updatedFormData, key)) {
            updatedFormData[key] = currentApplicant[key] === null ? "" : currentApplicant[key];
          }
        }
        
        setFormData(updatedFormData);

        if (currentApplicant.resume) {
          setResumePath(currentApplicant.resume);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  useEffect(() => {
    updateProgress();
  }, [formData]);

  useEffect(() => {
    if (formData.date_of_birth) {
      const calculatedAge = calculateAge(formData.date_of_birth);
      setFormData(prev => ({ ...prev, age: calculatedAge }));
    }
  }, [formData.date_of_birth]);

  function updateProgress() {
    const answeredQuestions = Object.keys(formData).filter(
      (key) => key !== 'resume' && formData[key] !== null && formData[key] !== undefined && formData[key] !== ""
    ).length;
    const calculatedProgress = Math.min(100, (answeredQuestions / TOTAL_FIELDS_FOR_PROGRESS) * 100);
    setProgress(calculatedProgress);
  }

  function createSurveyModel() {
    const surveyElements = [
      {
        type: "panel",
        name: "personal-info",
        title: "Personal Information",
        elements: [
          { type: "html", html: "<h4>Name</h4>" },
          {
            type: "text",
            name: "first_name",
            title: "First Name",
            defaultValue: formData.first_name,
            isRequired: true,
            validators: [{ type: "regex", regex: "^[A-Za-z\\s]+$", text: "First name should only contain letters and spaces." }],
          },
          {
            type: "text",
            name: "middle_name",
            title: "Middle Name",
            defaultValue: formData.middle_name,
            isRequired: true,
            validators: [{ type: "regex", regex: "^[A-Za-z\\s]*$", text: "Middle name should only contain letters and spaces." }],
            startWithNewLine: false,
          },
          {
            type: "text",
            name: "last_name",
            title: "Last Name",
            defaultValue: formData.last_name,
            isRequired: true,
            validators: [{ type: "regex", regex: "^[A-Za-z\\s]+$", text: "Last name should only contain letters and spaces." }],
            startWithNewLine: false,
          },
          {
            type: "text",
            name: "phone",
            title: "Mobile Number",
            inputType: "tel",
            placeholder: "Enter 10-digit phone number",
            defaultValue: formData.phone,
            isRequired: true,
            validators: [{ type: "regex", regex: "^[0-9]{10}$", text: "Phone number must be 10 digits." }],
            maxLength: 10,
          },
          {
            type: "text",
            name: "email",
            title: "Email ID",
            inputType: "email",
            defaultValue: formData.email,
            isRequired: true,
            readOnly: true,
            startWithNewLine: false,
          },
          {
            type: "dropdown",
            name: "gender",
            title: "Gender",
            defaultValue: formData.gender,
            isRequired: true,
            choices: ["Male", "Female", "Other", "Prefer not to say"],
          },
          {
            type: "text",
            name: "date_of_birth",
            title: "Date of Birth",
            inputType: "date",
            defaultValue: formData.date_of_birth,
            isRequired: true,
            startWithNewLine: false,
          },
          {
            type: "text",
            name: "age",
            title: "Age",
            defaultValue: formData.age,
            readOnly: true,
            startWithNewLine: false,
          },
          {
            type: "dropdown",
            name: "marital_status",
            title: "Marital Status",
            defaultValue: formData.marital_status,
            choices: ["Single", "Married", "Divorced", "Widowed", "Other"],
          },
        ],
      },
      {
        type: "panel",
        name: "address_info",
        title: "Address Information",
        elements: [
          { type: "text", name: "address_type", title: "Residential Address", defaultValue: formData.address_type, isRequired: true },
          { type: "dropdown", name: "country", title: "Country", defaultValue: formData.country, isRequired: true, choicesByUrl: { url: "https://surveyjs.io/api/CountriesExample" } },
          { type: "text", name: "state", title: "State", defaultValue: formData.state, isRequired: true, startWithNewLine: false },
          { type: "text", name: "district", title: "District", defaultValue: formData.district, isRequired: true },
          { type: "text", name: "tehsil", title: "Tehsil", defaultValue: formData.tehsil, startWithNewLine: false },
          { type: "text", name: "village", title: "Village/Locality", defaultValue: formData.village },
          { type: "text", name: "zip_code", title: "Pin Code", defaultValue: formData.zip_code, validators: [{ type: "regex", regex: "^[0-9]{5,10}$", text: "Enter a valid pin code." }], maxLength: 10, isRequired: true, startWithNewLine: false },
        ],
      },
      {
        type: "panel",
        name: "education_panel",
        title: "Education Details",
        elements: [
          { type: "dropdown", name: "education", title: "Education", defaultValue: formData.education, isRequired: true, choices: ["Secondary", "Higher Secondary", "Graduate", "Post Graduate", "Professional"] },
          { type: "text", name: "degree", title: "Degree", defaultValue: formData.degree, isRequired: true },
        ]
      },
      {
        type: "panel",
        name: "experience_panel",
        title: "Experience Details",
        elements: [
          { type: "dropdown", name: "experience", title: "Experience", defaultValue: formData.experience, isRequired: true, choices: ["Fresher", "Experienced"] },
          {
            type: "panel",
            name: "total_experience_panel",
            title: "Total Experience",
            visibleIf: "{experience} = 'Experienced'",
            elements: [
              { type: "text", name: "Work_total_experience_year", title: "Year", inputType: "number", min: 0, defaultValue: formData.Work_total_experience_year, isRequired: true },
              { type: "text", name: "Work_total_experience_months", title: "Month", inputType: "number", min: 0, max: 11, defaultValue: formData.Work_total_experience_months, isRequired: true, startWithNewLine: false },
            ]
          },
          {
            type: "panel",
            name: "current_company_panel",
            title: "Current Company Details",
            visibleIf: "{experience} = 'Experienced'",
            elements: [
              { type: "text", name: "current_comapny_name", title: "Current Company Name", defaultValue: formData.current_comapny_name, isRequired: true },
              { type: "comment", name: "current_company_address", title: "Company Address", rows: 3, defaultValue: formData.current_company_address, isRequired: true },
              { type: "text", name: "job_title", title: "Position", defaultValue: formData.job_title, isRequired: true },
              { type: "text", name: "current_ctc", title: "Current CTC", inputType: "number", step: "0.01", defaultValue: formData.current_ctc, isRequired: true },
              { type: "text", name: "gross", title: "Gross", inputType: "number", step: "0.01", defaultValue: formData.gross, isRequired: true, startWithNewLine: false },
              { type: "text", name: "net", title: "Net", inputType: "number", step: "0.01", defaultValue: formData.net, isRequired: true },
              { type: "text", name: "variables", title: "Variables", inputType: "number", step: "0.01", defaultValue: formData.variables, startWithNewLine: false },
              { type: "text", name: "current_notice_period_days", title: "Notice Period", inputType: "number", min: 0, defaultValue: formData.current_notice_period_days, isRequired: true },
              { type: "comment", name: "reason_for_leaving", title: "Reason for leaving", rows: 3, defaultValue: formData.reason_for_leaving, isRequired: true },
            ],
          },
          { type: "text", name: "referred_by", title: "Referred By", defaultValue: formData.referred_by },
          { type: "text", name: "referred_contact", title: "Referrer's Contact", defaultValue: formData.referred_contact },
        ]
      },
    ];

    if (!formData.acknowledged) {
  surveyElements.push({
    type: "panel",
    name: "declaration_panel",
    elements: [
      {
        type: "html",
        name: "declaration_html",
        html: `
          <div style="margin-bottom: 20px;">
            <h4 style="font-weight: bold; font-size: 0.9em; margin-bottom: 10px; text-align: justify; color: red;">
              Declaration and Acceptance of Terms and conditions
            </h4>
            <div style="border: 1px solid #eee; padding: 15px; border-radius: 5px; background-color: #f9f9f9;">
              <p style="font-weight: normal; text-align: justify; font-size: 0.8em; margin-bottom: 0;">
                I, hereby declare that all the personal, academic, and professional information provided by me on the VetTalent Hub Portal is true, correct, and complete to the best of my knowledge and belief. I understand that submission of false or misleading information, or omission of relevant facts, may lead to disqualification from the recruitment process, or if discovered at a later stage, may result in immediate termination of employment or cancellation of any offers made. The company reserves the right to verify any or all information provided by me at any stage of the selection or employment process. I accept that the decision of the company in such matters will be final and binding. Furthermore, I confirm that I have read, understood, and agreed to abide by all the terms, conditions, and policies laid down by the organization, and I will comply with them throughout my association with the company. By submitting this declaration, I give my full consent to VetTalent Hub and its authorized representatives to process and use my information for employment and administrative purposes, in accordance with applicable data protection laws.   
              </p>
            </div>
          </div>
        `
      },
      {
        type: "boolean",
        name: "acknowledged",
        titleLocation: "hidden", 
        label: "By checking this box, I confirm that I have read, understood, and agree to the declaration above.",
        isRequired: true,
        defaultValue: formData.acknowledged,
        renderAs: "checkbox",
        startWithNewLine: true 
      }
    ]
  });
}

    const survey = new Model({
      elements: surveyElements,
      showQuestionNumbers: false,
      showNavigationButtons: !formData.acknowledged,
      completeText: "Submit Profile",
      widthMode: "static",
      width: "100%",
      showCompletedPage: false,
    });

    

if (!formData.acknowledged) {
  survey.onAfterRenderSurvey.add((sender, options) => {
    const completeButton = options.htmlElement.querySelector(".sd-btn--action");
    if (!completeButton) return;
    const updateButtonState = () => {
      const ackQuestion = sender.getQuestionByName("acknowledged");
      completeButton.disabled = isSubmitting || !(ackQuestion && ackQuestion.value);
      completeButton.textContent = isSubmitting ? "Submitting..." : "Submit Profile";
    };
    updateButtonState(); 
    sender.onValueChanged.add(updateButtonState); 
  });
  survey.onComplete.add(handleSurveyCompletion);
}

    survey.onValueChanged.add((sender, options) => {
      if (options.name === "date_of_birth") {
        sender.setValue("age", calculateAge(options.value));
      }
    });

    survey.onAfterRenderQuestion.add((sender, options) => {
      const numericFields = ["phone", "current_notice_period_days", "Work_total_experience_year", "Work_total_experience_months"];
      if (numericFields.includes(options.question.name)) {
        const input = options.htmlElement.querySelector("input");
        if (input) input.addEventListener("keydown", preventNonNumericInput);
      }
    });

    return survey;
  }

  useEffect(() => {
    if (formData && formData.email) {
      setSurveyModel(createSurveyModel());
    }
  }, [formData, isSubmitting]);

  function handleSurveyCompletion(sender) {
    setIsSubmitting(true);
    const surveyData = sender.data;
    const userId = localStorage.getItem("user_id");

    if (!userId) {
      Swal.fire("Error!", "User session not found.", "error");
      setIsSubmitting(false);
      return;
    }

    const submissionFormData = new FormData();
    if (resumeFile) {
      submissionFormData.append("resume", resumeFile);
    } else if (!resumePath) {
      Swal.fire("Error!", "Please upload your resume.", "error");
      setIsSubmitting(false);
      return;
    }

    Object.entries(surveyData).forEach(([key, value]) => {
      submissionFormData.append(key, value ?? "");
    });
    submissionFormData.append("user_id", userId);

    axios.post("https://raasbackend.vetrinahealthcare.com/update_applicant/", submissionFormData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (e) => setProgress(Math.round((e.loaded / e.total) * 100)),
      })
      .then((res) => {
        Swal.fire({ icon: "success", title: "Success!", timer: 1500, showConfirmButton: false }).then(() => navigate("/job-openings"));
      })
      .catch((err) => {
        Swal.fire({ icon: "error", title: "Update Failed!", text: "An error occurred during submission." });
      })
      .finally(() => {
        setIsSubmitting(false);
        setProgress(0);
      });
  }

  function handleResume(e) {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        Swal.fire("Invalid File", "Please upload a PDF.", "warning");
        e.target.value = null;
        return;
      }
      setResumeFile(file);
      setResumePath(file.name);
      const pData = new FormData();
      pData.append("pdf_file", file);
      pData.append("applicant_id", localStorage.getItem("user_id"));
      axios.post("https://raasbackend.vetrinahealthcare.com/extract_text/", pData)
        .then(res => {
          setFormData(prev => ({
            ...prev,
            first_name: prev.first_name || res.data.First_Name || "",
            last_name: prev.last_name || res.data.Last_Name || "",
            phone: prev.phone || res.data.phone_number || "",
          }));
        });
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh", overflowY: "hidden" }}>
      <DashNavbar />
      <div style={{ display: "flex", flex: 1, overflowY: 'hidden' }}>
        <Sidebar />
        <div className="container submitform" style={{ flex: 1, overflowY: 'auto', paddingBottom: '20px' }}>
          <div style={{ backgroundColor: "#f3f3f3", padding: "15px", borderRadius: "8px", marginBottom: "20px" }}>
            <ProgressBar now={progress} label={`${progress.toFixed(0)}%`} className="my-3 mt-4">
              <ProgressBar striped variant={getColor(progress)} animated={progress < 100 && progress > 0} now={progress} />
            </ProgressBar>
            <h1 className="display-6 gradient-text mb-3">Profile Management</h1>
            <p>{formData.acknowledged ? "Profile acknowledged. Review details below." : "Please update your profile details. * indicates required."}</p>
            <hr />
            <form className="m-auto w-75 mt-3" onSubmit={(e) => e.preventDefault()}>
              <label className="form-label fw-bold">Upload resume * (PDF Only)</label>
              <input className="form-control form-control-lg" type="file" accept=".pdf" onChange={handleResume} />
              {resumePath && <div className="mt-2 text-muted">Current Resume: {resumePath.split('/').pop()}</div>}
            </form>
          </div>
          <div style={{ flex: 1, backgroundColor: "#fff", padding: "15px", borderRadius: "8px" }}>
            {surveyModel ? <Survey model={surveyModel} /> : <div className="text-center p-5"><Spinner animation="border" /> Loading Profile...</div>}
          </div>
          {isSubmitting && (
            <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
              <Spinner animation="border" variant="light" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Jobapplication;


// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { Model } from "survey-core";
// import { Survey } from "survey-react-ui";
// import "survey-core/defaultV2.min.css";
// import "../css/index.css";
// import axios from "axios";
// import Swal from "sweetalert2";
// import DashNavbar from "../Misc/DashNavbar";
// import Sidebar from "../Misc/Sidebar";
// import ProgressBar from "react-bootstrap/ProgressBar";
// import { Spinner } from "react-bootstrap";

// // Helper function for progress bar color
// function getColor(progress) {
//   if (progress >= 0 && progress < 25) {
//     return "danger";
//   } else if (progress >= 25 && progress < 50) {
//     return "warning";
//   } else if (progress >= 50 && progress < 75) {
//     return "primary";
//   } else {
//     return "success";
//   }
// }

// // Helper function to prevent non-numeric input
// function preventNonNumericInput(event) {
//   // Allow digits, Backspace, Delete, Arrow keys, Tab
//   if (
//     !/[0-9]/.test(event.key) &&
//     event.key !== "Backspace" &&
//     event.key !== "Delete" &&
//     event.key !== "ArrowLeft" &&
//     event.key !== "ArrowRight" &&
//     event.key !== "Tab"
//   ) {
//     event.preventDefault();
//   }
// }

// // Helper function to calculate age from date of birth
// function calculateAge(dateOfBirth) {
//   if (!dateOfBirth) return "";
//   const dob = new Date(dateOfBirth);
//   const today = new Date();
//   let age = today.getFullYear() - dob.getFullYear();
//   const monthDiff = today.getMonth() - dob.getMonth();
//   if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
//     age--;
//   }
//   return age.toString();
// }

// function Jobapplication(props) {
//   const [resumeFile, setResumeFile] = useState(null);
//   const [resumePath, setResumePath] = useState("");
//   const [formData, setFormData] = useState({
//     // Personal Information
//     first_name: "",
//     middle_name: "",
//     last_name: "",
//     phone: "",
//     email: "",
//     gender: "",
//     date_of_birth: "",
//     age: "",
//     marital_status: "",
//     referred_by: "",
//     referred_contact: "",
//     acknowledged: false,

//     // Address Information
//     address_type: "",
//     country: "",
//     state: "",
//     district: "",
//     tehsil: "",
//     village: "",
//     zip_code: "",

//     // Education Information
//     education: "",
//     degree: "",

//     // Work Experience
//     experience: "",
//     Work_total_experience_months: "",
//     Work_total_experience_year: "",
//     current_comapny_name: "",
//     current_company_address: "",
//     job_title: "",
//     current_ctc: "",
//     gross: "",
//     net: "",
//     variables: "",
//     current_notice_period_days: "",
//     reason_for_leaving: "",

//     resume: "",
//   });

//   const [progress, setProgress] = useState(0);
//   const navigate = useNavigate();
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [surveyModel, setSurveyModel] = useState(null);

//   // Constants
//   const TOTAL_FIELDS_FOR_PROGRESS = 33; // Adjusted for the actual number of fields including referred_by

//   // Fetch initial data
//   useEffect(() => {
//     const userEmail = localStorage.getItem("email");
//     if (userEmail) {
//       setFormData((prevState) => ({ ...prevState, email: userEmail }));
//       fetchData(userEmail);
//     }
//   }, []);

//   async function fetchData(userEmail) {
//     try {
//       const userId = localStorage.getItem("user_id");
//       if (!userId) {
//         console.error("User ID not found in localStorage");
//         return;
//       }

//       const response = await axios.get(
//         `https://raasbackend.vetrinahealthcare.com/applicants/data/?user_id=${userId}`
//       );

//       if (response.data && response.data.length > 0) {
//         const applicantFields = response.data[0]?.fields || response.data[0];

//         const updatedFormData = { ...formData };
//         for (const key in applicantFields) {
//           if (Object.hasOwnProperty.call(applicantFields, key)) {
//             updatedFormData[key] = applicantFields[key] === null ? "" : applicantFields[key];
//           }
//         }

//         setFormData(updatedFormData);

//         if (applicantFields.resume) {
//           setResumePath(applicantFields.resume);
//         }
//       } else {
//         console.warn("No applicant data found for user ID:", userId);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   }

//   // Update progress when formData changes
//   useEffect(() => {
//     updateProgress();
//   }, [formData]);

//   // Update age when date of birth changes
//   useEffect(() => {
//     if (formData.date_of_birth) {
//       const calculatedAge = calculateAge(formData.date_of_birth);
//       setFormData(prev => ({ ...prev, age: calculatedAge }));
//     }
//   }, [formData.date_of_birth]);

//   function updateProgress() {
//     const answeredQuestions = Object.keys(formData).filter(
//       (key) => key !== 'resume' && formData[key] !== null && formData[key] !== undefined && formData[key] !== ""
//     ).length;
//     const calculatedProgress = Math.min(100, (answeredQuestions / TOTAL_FIELDS_FOR_PROGRESS) * 100);
//     setProgress(calculatedProgress);
//   }

//   // Function to create the survey model based on current formData
//   // Function to create the survey model based on current formData
//   function createSurveyModel() {
//     // Base elements that are always present in the survey
//     const surveyElements = [
//       {
//         type: "panel",
//         name: "personal-info",
//         title: "Personal Information",
//         elements: [
//           {
//             type: "html",
//             html: "<h4>Name</h4>"
//           },
//           {
//             type: "text",
//             name: "first_name",
//             title: "First Name",
//             defaultValue: formData.first_name,
//             isRequired: true,
//             validators: [{ type: "regex", regex: "^[A-Za-z\\s]+$", text: "First name should only contain letters and spaces." }],
//           },
//           {
//             type: "text",
//             name: "middle_name",
//             title: "Middle Name",
//             defaultValue: formData.middle_name,
//             isRequired: true,
//             validators: [{ type: "regex", regex: "^[A-Za-z\\s]*$", text: "Middle name should only contain letters and spaces." }],
//             startWithNewLine: false,
//           },
//           {
//             type: "text",
//             name: "last_name",
//             title: "Last Name",
//             defaultValue: formData.last_name,
//             isRequired: true,
//             validators: [{ type: "regex", regex: "^[A-Za-z\\s]+$", text: "Last name should only contain letters and spaces." }],
//             startWithNewLine: false,
//           },
//           {
//             type: "text",
//             name: "phone",
//             title: "Mobile Number",
//             inputType: "tel",
//             placeholder: "Enter 10-digit phone number",
//             defaultValue: formData.phone,
//             isRequired: true,
//             validators: [{ type: "regex", regex: "^[0-9]{10}$", text: "Phone number must be 10 digits." }],
//             maxLength: 10,
//           },
//           {
//             type: "text",
//             name: "email",
//             title: "Email ID",
//             inputType: "email",
//             placeholder: "mail@example.com",
//             defaultValue: formData.email,
//             isRequired: true,
//             readOnly: true,
//             startWithNewLine: false,
//           },
//           {
//             type: "dropdown",
//             name: "gender",
//             title: "Gender",
//             defaultValue: formData.gender,
//             isRequired: true,
//             choices: [
//               { value: "Male", text: "Male" },
//               { value: "Female", text: "Female" },
//               { value: "Other", text: "Other" },
//               { value: "Prefer not to say", text: "Prefer not to say" },
//             ],
//           },
//           {
//             type: "text",
//             name: "date_of_birth",
//             title: "Date of Birth",
//             inputType: "date",
//             defaultValue: formData.date_of_birth,
//             isRequired: true,
//             startWithNewLine: false,
//           },
//           {
//             type: "text",
//             name: "age",
//             title: "Age",
//             defaultValue: formData.age,
//             readOnly: true,
//             startWithNewLine: false,
//           },
//           {
//             type: "dropdown",
//             name: "marital_status",
//             title: "Marital Status",
//             defaultValue: formData.marital_status,
//             choices: [
//               { value: "", text: "Select..." },
//               { value: "Single", text: "Single" },
//               { value: "Married", text: "Married" },
//               { value: "Divorced", text: "Divorced" },
//               { value: "Widowed", text: "Widowed" },
//               { value: "Other", text: "Other" },
//             ],
//           },

//         ],
//       },
//       {
//         type: "panel",
//         name: "address_info",
//         title: "Address Information",
//         elements: [
//           {
//             type: "text",
//             name: "address_type",
//             title: "Residential Address",
//             defaultValue: formData.address_type,
//             isRequired: true
//           },

//           {
//             type: "dropdown",
//             name: "country",
//             title: "Country",
//             defaultValue: formData.country,
//             isRequired: true,
//             choicesByUrl: { url: "https://surveyjs.io/api/CountriesExample" },
//           },
//           {
//             type: "text",
//             name: "state",
//             title: "State",
//             defaultValue: formData.state,
//             isRequired: true,
//             startWithNewLine: false,
//           },
//           {
//             type: "text",
//             name: "district",
//             title: "District",
//             defaultValue: formData.district,
//             isRequired: true,
//           },
//           {
//             type: "text",
//             name: "tehsil",
//             title: "Tehsil",
//             defaultValue: formData.tehsil,
//             startWithNewLine: false,
//           },
//           {
//             type: "text",
//             name: "village",
//             title: "Village/Locality",
//             defaultValue: formData.village,
//           },
//           {
//             type: "text",
//             name: "zip_code",
//             title: "Pin Code",
//             inputType: "text",
//             defaultValue: formData.zip_code,
//             validators: [{ type: "regex", regex: "^[0-9]{5,10}$", text: "Enter a valid pin code." }],
//             maxLength: 10,
//             isRequired: true,
//             startWithNewLine: false,
//           },
//         ],
//       },
//       {
//         type: "panel",
//         name: "education_panel",
//         title: "Education Details",
//         elements: [
//           {
//             type: "dropdown",
//             name: "education",
//             title: "Education",
//             defaultValue: formData.education,
//             isRequired: true,
//             choices: [
//               { value: "Secondary", text: "Secondary" },
//               { value: "Higher Secondary", text: "Higher Secondary" },
//               { value: "Graduate", text: "Graduate" },
//               { value: "Post Graduate", text: "Post Graduate" },
//               { value: "Professional", text: "Professional" }
//             ],
//           },
//           {
//             type: "text",
//             name: "degree",
//             title: "Degree",
//             defaultValue: formData.degree,
//             isRequired: true,
//           },
//         ]
//       },
//       {
//         type: "panel",
//         name: "experience_panel",
//         title: "Experience Details",
//         elements: [
//           {
//             type: "dropdown",
//             name: "experience",
//             title: "Experience",
//             defaultValue: formData.experience,
//             isRequired: true,
//             choices: [
//               { value: "Fresher", text: "Fresher" },
//               { value: "Experienced", text: "Experienced" }
//             ],
//           },
//           {
//             type: "panel",
//             name: "total_experience_panel",
//             title: "Total Experience",
//             visibleIf: "{experience} = 'Experienced'",
//             elements: [
//               { type: "text", name: "Work_total_experience_year", title: "Year", inputType: "number", min: 0, defaultValue: formData.Work_total_experience_year, isRequired: true },
//               { type: "text", name: "Work_total_experience_months", title: "Month", inputType: "number", min: 0, max: 11, defaultValue: formData.Work_total_experience_months, isRequired: true, startWithNewLine: false },
//             ]
//           },
//           {
//             type: "panel",
//             name: "current_company_panel",
//             title: "Current Company Details",
//             visibleIf: "{experience} = 'Experienced'",
//             elements: [
//               { type: "text", name: "current_comapny_name", title: "Current Company Name", defaultValue: formData.current_comapny_name, isRequired: true },
//               { type: "comment", name: "current_company_address", title: "Company Address", rows: 3, defaultValue: formData.current_company_address, isRequired: true },
//               { type: "text", name: "job_title", title: "Position", defaultValue: formData.job_title, isRequired: true },
//               { type: "text", name: "current_ctc", title: "Current CTC", inputType: "number", step: "0.01", defaultValue: formData.current_ctc, isRequired: true },
//               { type: "text", name: "gross", title: "Gross", inputType: "number", step: "0.01", defaultValue: formData.gross, isRequired: true, startWithNewLine: false },
//               { type: "text", name: "net", title: "Net", inputType: "number", step: "0.01", defaultValue: formData.net, isRequired: true },
//               { type: "text", name: "variables", title: "Variables", inputType: "number", step: "0.01", defaultValue: formData.variables, startWithNewLine: false },
//               { type: "text", name: "current_notice_period_days", title: "Notice Period", inputType: "number", min: 0, defaultValue: formData.current_notice_period_days, isRequired: true },
//               { type: "comment", name: "reason_for_leaving", title: "Reason for leaving", rows: 3, defaultValue: formData.reason_for_leaving, isRequired: true },
//             ],
//           },
//           {
//             type: "text",
//             name: "referred_by",
//             title: "Referred By",
//             defaultValue: formData.referred_by,
//             description: "If you were referred by someone, please enter their name",
//             placeholder: "Enter referrer's name (optional)",
//           },
//           {
//             type: "text",
//             name: "referred_contact",
//             title: "Referrer's Contact (Phone/Email)",
//             defaultValue: formData.referred_contact,
//             placeholder: "Enter referrer's phone or email (optional)",
//           },
//         ]
//       },
//     ];

    
//     if (!formData.acknowledged) {
//       surveyElements.push({
//         type: "panel",
//         name: "declaration_panel",
//         // title: "Final Declaration and Submission",
//         elements: [
//           {
//             type: "html",
//             name: "declaration_html",
//             // ======================= MODIFICATION START =======================
//             // Added an ID to the <details> tag for easy selection in JavaScript
//             html: `
//               <details id="declaration-details">
//                 <summary style="cursor: pointer; font-weight: bold; font-size: 0.8em; margin-bottom: 10px; text-align: justify; color: red;">Declaration and Acceptance of Terms and conditions.</summary>
//                 <div style="border: 1px solid #eee; padding: 15px; border-radius: 5px; margin-top: 10px; background-color: #f9f9f9;">
//                   <p style="font-weight: normal; text-align: justify; font-size: 0.8em;">
//                     I, hereby declare that all the personal, academic, and professional information provided by me on the VetTalent Hub Portal is true, correct, and complete to the best of my knowledge and belief. I understand that submission of false or misleading information, or omission of relevant facts, may lead to disqualification from the recruitment process, or if discovered at a later stage, may result in immediate termination of employment or cancellation of any offers made. The company reserves the right to verify any or all information provided by me at any stage of the selection or employment process. I accept that the decision of the company in such matters will be final and binding. Furthermore, I confirm that I have read, understood, and agreed to abide by all the terms, conditions, and policies laid down by the organization, and I will comply with them throughout my association with the company. By submitting this declaration, I give my full consent to VetTalent Hub and its authorized representatives to process and use my information for employment and administrative purposes, in accordance with applicable data protection laws.
//                   </p>
//                 </div>
//               </details>
//             `
//             // ======================== MODIFICATION END ========================
//           },
//           {
//             type: "boolean",
//             name: "acknowledged",
//             titleLocation: "hidden", 
//             label: "By checking this box, I confirm that I have read, understood, and agree to the declaration above.",
//             isRequired: true,
//             defaultValue: formData.acknowledged,
//             renderAs: "checkbox",
//             startWithNewLine: true 
//           }
//         ]
//       });
//     }


//     const surveyDefinition = {
//       elements: surveyElements,
//       showQuestionNumbers: false,
//       showNavigationButtons: !formData.acknowledged, 
//       completeText: "Submit Profile",
//       widthMode: "static",
//       width: "100%",
//       showCompletedPage: false,
//     };

//     const survey = new Model(surveyDefinition);

//     // ======================= MODIFICATION START =======================
//     // This new handler will control the checkbox's enabled/disabled state.
//     survey.onAfterRenderPanel.add((sender, options) => {
//         // We only want to run this logic for our specific declaration panel
//         if(options.panel.name === 'declaration_panel') {
//             const detailsElement = options.htmlElement.querySelector('#declaration-details');
//             const acknowledgedQuestion = options.panel.getQuestionByName('acknowledged');

//             if(detailsElement && acknowledgedQuestion) {
//                 // 1. Initially, disable the checkbox.
//                 acknowledgedQuestion.readOnly = true;

//                 // 2. Add an event listener to the <details> element.
//                 detailsElement.addEventListener('toggle', (event) => {
//                     // 3. When the details are opened, enable the checkbox.
//                     if (detailsElement.open) {
//                         acknowledgedQuestion.readOnly = false;
//                     } 
//                     // Optional: re-disable if the user closes it again.
//                     // else {
//                     //    acknowledgedQuestion.readOnly = true;
//                     // }
//                 });
//             }
//         }
//     });
//     // ======================== MODIFICATION END ========================


//     if (!formData.acknowledged) {
//       survey.onAfterRenderSurvey.add((sender, options) => {
//         const completeButton = options.htmlElement.querySelector(".sd-btn--action");
//         if (!completeButton) return;

//         const updateButtonState = () => {
//           let isAckDisabled = true;
//           const ackQuestion = sender.getQuestionByName("acknowledged");
          
//           if (ackQuestion && ackQuestion.value) {
//             isAckDisabled = false;
//           }

//           completeButton.disabled = isSubmitting || isAckDisabled;
//           completeButton.textContent = isSubmitting ? "Submitting..." : "Submit Profile";
//         };

//         updateButtonState(); 
//         sender.onValueChanged.add(updateButtonState); 
//       });

//       survey.onComplete.add(handleSurveyCompletion);
//     }

    
//     survey.onValueChanged.add((sender, options) => {
//       if (options.name === "date_of_birth") {
//         const age = calculateAge(options.value);
//         sender.setValue("age", age);
//       }
//     });

//     survey.onAfterRenderQuestion.add((sender, options) => {
//       if (options.question.name === "phone" ||
//         options.question.name === "current_notice_period_days" ||
//         options.question.name === "Work_total_experience_year" ||
//         options.question.name === "Work_total_experience_months") {
//         const input = options.htmlElement.querySelector("input");
//         if (input) {
//           input.addEventListener("keydown", preventNonNumericInput);
//         }
//       }
//     });

//     return survey;
//   }

//   useEffect(() => {
//     if (formData && formData.email) {
//       const newSurveyModel = createSurveyModel();
//       setSurveyModel(newSurveyModel);
//     }

//     return () => {
//       if (surveyModel) {
//         surveyModel.onAfterRenderSurvey.clear();
//         surveyModel.onAfterRenderQuestion.clear();
//         surveyModel.onAfterRenderPanel.clear(); // Cleanup the new handler
//         surveyModel.onComplete.clear();
//         surveyModel.onValueChanged.clear();
//       }
//     };
//   }, [formData, isSubmitting]);

//   // Handles the actual submission logic
//   function handleSurveyCompletion(sender) {
//     setIsSubmitting(true);
//     setProgress(0);
//     const surveyData = sender.data;
//     const userId = localStorage.getItem("user_id");

//     if (!userId) {
//       Swal.fire("Error!", "User session not found. Please log in again.", "error");
//       setIsSubmitting(false);
//       return;
//     }

//     const submissionFormData = new FormData();

//     // Resume Handling
//     const newResumeUploaded = resumeFile instanceof File;

//     if (newResumeUploaded) {
//       submissionFormData.append("resume", resumeFile);
//     } else if (!resumePath) {
//       Swal.fire("Error!", "Please upload your resume.", "error");
//       setIsSubmitting(false);
//       return;
//     }

//     // Append survey data
//     Object.entries(surveyData).forEach(([key, value]) => {
//       if (value !== null && value !== undefined) {
//         submissionFormData.append(key, value);
//       } else {
//         submissionFormData.append(key, "");
//       }
//     });

//     // Append user_id
//     submissionFormData.append("user_id", userId);

//     // API Call
//     const backendUrl = "https://raasbackend.vetrinahealthcare.com/update_applicant/";

//     axios
//       .post(backendUrl, submissionFormData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//         onUploadProgress: (progressEvent) => {
//           if (progressEvent.total) {
//             const calculatedProgress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
//             setProgress(calculatedProgress);
//           }
//         },
//       })
//       .then((response) => {
//         Swal.fire({
//           icon: "success",
//           title: "Success!",
//           text: response.data.message || "Your profile has been updated successfully.",
//           timer: 1500,
//           timerProgressBar: true,
//           showConfirmButton: false,
//         }).then(() => {
//           navigate("/job-openings");
//         });
//         console.log("Update Response:", response.data);
//       })
//       .catch((error) => {
//         console.error("Update Error:", error);
//         let errorMessage = "An error occurred while updating your profile.";
//         if (error.response && error.response.data) {
//           if (error.response.data.errors) {
//             errorMessage = Object.entries(error.response.data.errors)
//               .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
//               .join("\n");
//           } else if (error.response.data.error_message) {
//             errorMessage = error.response.data.error_message;
//           } else if (error.response.data.error) { // Handle single error string
//             errorMessage = error.response.data.error;
//           }
//         }
//         Swal.fire({
//           icon: "error",
//           title: "Update Failed!",
//           text: errorMessage,
//           showConfirmButton: true,
//         });
//       })
//       .finally(() => {
//         setIsSubmitting(false);
//         setProgress(0);
//       });
//   }

//   // Handle manual resume file selection
//   function handleResume(e) {
//     const file = e.target.files[0];
//     if (file) {
//       if (file.type !== "application/pdf") {
//         Swal.fire("Invalid File Type", "Please upload a PDF file only.", "warning");
//         e.target.value = null;
//         return;
//       }
//       setResumeFile(file);
//       setResumePath(file.name);

//       // Resume Parsing
//       const parsingFormData = new FormData();
//       parsingFormData.append("pdf_file", file);
//       parsingFormData.append("applicant_id", localStorage.getItem("user_id"));

//       axios.post("https://raasbackend.vetrinahealthcare.com/extract_text/", parsingFormData)
//         .then(response => {
//           const { data } = response;
//           setFormData(prevFormData => ({
//             ...prevFormData,
//             first_name: prevFormData.first_name || data.First_Name || "",
//             last_name: prevFormData.last_name || data.Last_Name || "",
//             phone: prevFormData.phone || data.phone_number || "",
//           }));

//           const newSurveyModel = createSurveyModel();
//           setSurveyModel(newSurveyModel);
//         })
//         .catch(error => {
//           console.error("Error extracting text from PDF:", error);
//         });
//     } else {
//       setResumeFile(null);
//       fetchData(formData.email);
//     }
//   }

//   return (
//     <>
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           height: "100vh",
//           overflowY: "hidden",
//         }}
//       >
//         <DashNavbar />
//         <div style={{ display: "flex", flex: 1, overflowY: 'hidden' }}>
//           <Sidebar />
//           <div className="container submitform" style={{ flex: 1, overflowY: 'auto', paddingBottom: '20px' }}>
//             <div className="" style={{ backgroundColor: "#f3f3f3", padding: "15px", borderRadius: "8px", marginBottom: "20px" }}>
//               {/* Progress Bar */}
//               <ProgressBar now={progress} label={`${progress.toFixed(0)}%`} className="my-3 mt-4">
//                 <ProgressBar
//                   striped
//                   variant={getColor(progress)}
//                   animated={progress < 100 && progress > 0}
//                   now={progress}
//                   label={`${progress.toFixed(0)}%`}
//                 />
//               </ProgressBar>

//               <h1 className="display-6 gradient-text mb-3">Profile Management</h1>
//               {formData.acknowledged ? (
//                 <p>Your profile has been submitted and acknowledged. You may review your details below.</p>
//               ) : (
//                 <p>Please fill out or update your profile details below. Fields marked with * are required.</p>
//               )}
//               <hr />
//               {/* Resume Upload Section */}
//               <form className="m-auto w-75 mt-3" onSubmit={(e) => e.preventDefault()}>
//                 <div>
//                   <label htmlFor="resumeInput" className="form-label fw-bold">
//                     Upload your resume <span className="text-danger">*</span> (PDF Only)
//                   </label>
//                   <input
//                     className="form-control form-control-lg"
//                     id="resumeInput"
//                     type="file"
//                     name="resume"
//                     accept=".pdf"
//                     onChange={handleResume}
//                   />
//                   {/* Display existing path or new file name */}
//                   {resumePath && (
//                     <div className="mt-2 text-muted">
//                       Current Resume: {resumePath.split('/').pop()}
//                     </div>
//                   )}
//                 </div>
//               </form>
//             </div>

//             {/* Survey Section */}
//             <div style={{ flex: 1, backgroundColor: "#fff", padding: "15px", borderRadius: "8px" }}>
//               {surveyModel ? (
//                 <Survey model={surveyModel} />
//               ) : (
//                 <div className="text-center p-5">
//                   <Spinner animation="border" /> Loading Profile Form...
//                 </div>
//               )}
//             </div>

//             {/* Loading Spinner during Submission */}
//             {isSubmitting && (
//               <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 9999 }}>
//                 <Spinner animation="border" variant="light" role="status">
//                   <span className="visually-hidden">Submitting...</span>
//                 </Spinner>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Jobapplication;

// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { Model } from "survey-core";
// import { Survey } from "survey-react-ui";
// import "survey-core/defaultV2.min.css";
// import "../css/index.css";
// import axios from "axios";
// import Swal from "sweetalert2";
// import DashNavbar from "../Misc/DashNavbar";
// import Sidebar from "../Misc/Sidebar";
// import ProgressBar from "react-bootstrap/ProgressBar";
// import { Spinner } from "react-bootstrap";

// // Helper function for progress bar color
// function getColor(progress) {
//   if (progress >= 0 && progress < 25) {
//     return "danger";
//   } else if (progress >= 25 && progress < 50) {
//     return "warning";
//   } else if (progress >= 50 && progress < 75) {
//     return "primary";
//   } else {
//     return "success";
//   }
// }

// // Helper function to prevent non-numeric input (can be kept if needed for specific fields)
// function preventNonNumericInput(event) {
//   // Allow digits, Backspace, Delete, Arrow keys, Tab
//   if (
//     !/[0-9]/.test(event.key) &&
//     event.key !== "Backspace" &&
//     event.key !== "Delete" &&
//     event.key !== "ArrowLeft" &&
//     event.key !== "ArrowRight" &&
//     event.key !== "Tab" // Allow Tab for navigation
//   ) {
//     event.preventDefault();
//   }
// }

// function Jobapplication(props) {
//   const [resumeFile, setResumeFile] = useState(null); // State for the actual file object
//   const [resumePath, setResumePath] = useState(""); // State for displaying existing path or new file name
//   const [formData, setFormData] = useState({
//     // Initialize with keys matching model fields likely to be fetched
//     email: "",
//     first_name: "",
//     middle_name: "",
//     last_name: "",
//     phone: "",
//     gender: "",
//     date_of_birth: "",
//     age: "",
//     address_type: "",
//     country: "",
//     state: "",
//     city: "",
//     district: "",
//     tehsil: "",
//     village: "",
//     zip_code: "",
//     secondary_college_name: "",
//     field: "", // General/Secondary field
//     secondary_start_date: "",
//     secondary_end_date: "",
//     secondary_percentage: "",
//     higher_secondary_college_name: "",
//     higher_secondary_field: "",
//     higher_secondary_start_date: "",
//     higher_secondary_end_date: "",
//     higher_secondary_percentage: "",
//     graduation_college: "",
//     graduation_branch: "",
//     graduation_start_date: "",
//     graduation_end_date: "",
//     graduation_percentage: "",
//     post_graduate_college: "",
//     post_graduate_branch: "",
//     post_graduate_start_date: "",
//     post_graduate_end_date: "",
//     post_graduate_percentage: "",
//     degree: "",
//     Work_total_experience_months: "",
//     Work_total_experience_year: "",
//     current_comapny_name: "",
//     current_company_address: "",
//     job_title: "",
//     current_ctc: "",
//     gross: "",
//     net: "",
//     variables: "",
//     current_notice_period_days: "",
//     reason_for_leaving: "",
//     resume: "", // Keep for tracking existing path from fetch
//     street_address: "",
//     employee_id: "",
//     referred_by: "",
//     timezone: "",
//     // Add any other fields from your model that need initial state or handling
//   });
//   const [progress, setProgress] = useState(0);
//   const navigate = useNavigate();
//   // const [isLoading, setIsLoading] = useState(false); // Consider if needed elsewhere
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [surveyModel, setSurveyModel] = useState(null); // State to hold the survey model instance

//   // --- Constants ---
//   // Recalculate based on the fields defined in the survey model below
//   // Let's count the fields in the updated survey definition: ~54 fields
//   const TOTAL_FIELDS_FOR_PROGRESS = 54;

//   // Fetch initial data
//   useEffect(() => {
//     const userEmail = localStorage.getItem("email");
//     if (userEmail) {
//       // Set email initially, fetch will overwrite other fields
//       setFormData((prevState) => ({ ...prevState, email: userEmail }));
//       fetchData(userEmail);
//     }
//   }, []);

//   async function fetchData(userEmail) {
//     try {
//       const userId = localStorage.getItem("user_id");
//       if (!userId) {
//         console.error("User ID not found in localStorage");
//         return;
//       }
//       // Make sure this endpoint returns data matching the *updated* Applicant model
//       const response = await axios.get(
//         `https://raasbackend.vetrinahealthcare.com/applicants/data/?user_id=${userId}`
//       );

//       if (response.data && response.data.length > 0) {
//         // Assuming the backend sends fields within response.data[0].fields
//         // If structure is different (e.g., response.data.fields), adjust accordingly
//         const applicantFields = response.data[0]?.fields || response.data[0]; // Adjust based on actual response structure

//         // Create a new state object merging existing state with fetched data
//         // Ensure fetched null values become empty strings for controlled inputs
//         const updatedFormData = { ...formData }; // Start with existing or initial state
//         for (const key in applicantFields) {
//           if (Object.hasOwnProperty.call(applicantFields, key)) {
//             // Ensure the key exists in our initial formData state or add it
//             updatedFormData[key] = applicantFields[key] === null ? "" : applicantFields[key];
//           }
//         }

//         setFormData(updatedFormData); // Update the entire state at once

//         if (applicantFields.resume) {
//           setResumePath(applicantFields.resume); // Store existing resume path
//         }
//       } else {
//         console.warn("No applicant data found for user ID:", userId);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       // Handle fetch error (e.g., show a message to the user)
//     }
//   }

//   // Update progress when formData changes
//   useEffect(() => {
//     updateProgress();
//   }, [formData]); // Dependency array includes formData

//   function updateProgress() {
//     // Filter out null, undefined, and empty strings, and potentially specific keys like 'resume' object path
//     const answeredQuestions = Object.keys(formData).filter(
//       (key) => key !== 'resume' && formData[key] !== null && formData[key] !== undefined && formData[key] !== ""
//     ).length;
//     const calculatedProgress = Math.min(100, (answeredQuestions / TOTAL_FIELDS_FOR_PROGRESS) * 100);
//     setProgress(calculatedProgress);
//   }


//   // Function to create the survey model based on current formData
//   function createSurveyModel() {
//     const surveyDefinition = {
//       elements: [
//         {
//           type: "panel",
//           name: "personal-info",
//           title: "Personal Information",
//           elements: [
//             {
//               type: "text",
//               name: "first_name",
//               title: "First name",
//               defaultValue: formData.first_name,
//               isRequired: true,
//               validators: [{ type: "regex", regex: "^[A-Za-z\\s]+$", text: "First name should only contain letters and spaces." }],
//             },
//             {
//               type: "text",
//               name: "middle_name",
//               title: "Middle name",
//               defaultValue: formData.middle_name,
//               isRequired: true, validators: [{ type: "regex", regex: "^[A-Za-z\\s]*$", text: "Middle name should only contain letters and spaces." }],
//             },
//             {
//               type: "text",
//               name: "last_name",
//               startWithNewLine: false,
//               title: "Last name",
//               defaultValue: formData.last_name,
//               isRequired: true,
//               validators: [{ type: "regex", regex: "^[A-Za-z\\s]+$", text: "Last name should only contain letters and spaces." }],
//             },
//             {
//               type: "dropdown",
//               name: "gender",
//               title: "Gender",
//               defaultValue: formData.gender,
//               // isRequired: true, // Make required if necessary
//               choices: [
//                 { value: "Male", text: "Male" },
//                 { value: "Female", text: "Female" },
//                 { value: "Other", text: "Other" },
//                 { value: "Prefer not to say", text: "Prefer not to say" },
//               ],
//             },
//             {
//               type: "text",
//               name: "date_of_birth",
//               title: "Date of Birth",
//               inputType: "date",
//               defaultValue: formData.date_of_birth,
//               isRequired: true, startWithNewLine: false, // Adjust layout as needed
//             },
//             {
//               type: "text",
//               name: "age",
//               title: "Age",
//               inputType: "age",
//               defaultValue: formData.age,
//               isRequired: true, startWithNewLine: false, // Adjust layout as needed
//             },
//             {
//               type: "text",
//               name: "email",
//               title: "Email",
//               inputType: "email",
//               placeholder: "mail@example.com",
//               defaultValue: formData.email,
//               isRequired: true,
//               readOnly: true, // Assuming email is fetched and shouldn't be changed
//               startWithNewLine: false,
//             },
//             {
//               // Combined phone input if desired, or keep separate
//               type: "text",
//               name: "phone",
//               title: "Phone Number",
//               inputType: "tel",
//               placeholder: "Enter 10-digit phone number",
//               defaultValue: formData.phone, // Convert to string if needed
//               isRequired: true,
//               validators: [{ type: "regex", regex: "^[0-9]{10}$", text: "Phone number must be 10 digits." }],
//               maxLength: 10,
//               // Add onKeyDown={preventNonNumericInput} if needed, but regex validator is better
//             },
//             {
//               type: "text",
//               name: "referred_by",
//               title: "Referred By (Optional)",
//               defaultValue: formData.referred_by,
//               startWithNewLine: false,
//             },
//             {
//               type: "text",
//               name: "employee_id",
//               title: "Employee ID (If applicable, else N/A)",
//               defaultValue: formData.employee_id,
//             },
//           ],
//         },
//         {
//           type: "panel",
//           name: "address_info",
//           title: "Address",
//           elements: [
//             {
//               type: "dropdown",
//               name: "address_type",
//               title: "Type of Address",
//               defaultValue: formData.address_type,
//               choices: [{ value: "home", text: "Home" }, { value: "other", text: "Other" }],
//             },
//             { type: "text", name: "street_address", title: "Street Address", isRequired: true, defaultValue: formData.street_address },
//             { type: "text", name: "village", title: "Village/Locality", defaultValue: formData.village, startWithNewLine: false },
//             { type: "text", name: "tehsil", title: "Tehsil/Taluk", defaultValue: formData.tehsil },
//             { type: "text", name: "city", title: "City", defaultValue: formData.city, startWithNewLine: false },
//             { type: "text", name: "district", title: "District", defaultValue: formData.district },
//             {
//               // Consider making State a dropdown for consistency if feasible
//               type: "text", // Or dropdown
//               name: "state",
//               title: "State",
//               defaultValue: formData.state,
//               startWithNewLine: false,
//               // Example dropdown choices if preferred:
//               /* choices: [ "Andhra Pradesh", "Arunachal Pradesh", ... ], */
//             },
//             {
//               type: "dropdown", // Use dropdown for country
//               name: "country",
//               title: "Country",
//               defaultValue: formData.country,
//               choicesByUrl: { url: "https://surveyjs.io/api/CountriesExample" }, // Example source
//             },

//             {
//               type: "text",
//               name: "zip_code",
//               title: "Zip/Pin code",
//               inputType: "text", // Use text to allow leading zeros if needed, validate format
//               defaultValue: formData.zip_code,
//               validators: [{ type: "regex", regex: "^[0-9]{5,10}$", text: "Enter a valid zip/pin code." }], // Adjust regex as needed
//               maxLength: 10,
//               isRequired: true,
//               startWithNewLine: false,
//             },
//           ],
//         },
//         // --- Updated Education Section ---
//         {
//           type: "panel",
//           name: "education_panel",
//           title: "Education Details",
//           elements: [
//             // Secondary Education
//             { type: "html", html: "<h4>Secondary Education (10th Grade)</h4>" },
//             { type: "text", name: "secondary_college_name", title: "School/Board Name", defaultValue: formData.secondary_college_name },
//             { type: "text", name: "field", title: "Field/Stream (if applicable)", defaultValue: formData.field, startWithNewLine: false }, // General field
//             { type: "text", name: "secondary_start_date", title: "Start Date", inputType: "date", defaultValue: formData.secondary_start_date },
//             { type: "text", name: "secondary_end_date", title: "End Date/Passing Year", inputType: "date", defaultValue: formData.secondary_end_date, startWithNewLine: false },
//             { type: "text", name: "secondary_percentage", title: "Percentage/Grade", inputType: "number", step: "0.01", defaultValue: formData.secondary_percentage },

//             // Higher Secondary Education
//             { type: "html", html: "<hr/><h4>Higher Secondary Education (12th Grade/Equivalent)</h4>" },
//             { type: "text", name: "higher_secondary_college_name", title: "School/College/Board Name", defaultValue: formData.higher_secondary_college_name },
//             { type: "text", name: "higher_secondary_field", title: "Field/Stream", defaultValue: formData.higher_secondary_field, startWithNewLine: false },
//             { type: "text", name: "higher_secondary_start_date", title: "Start Date", inputType: "date", defaultValue: formData.higher_secondary_start_date },
//             { type: "text", name: "higher_secondary_end_date", title: "End Date/Passing Year", inputType: "date", defaultValue: formData.higher_secondary_end_date, startWithNewLine: false },
//             { type: "text", name: "higher_secondary_percentage", title: "Percentage/Grade", inputType: "number", step: "0.01", defaultValue: formData.higher_secondary_percentage },

//             // Graduation
//             { type: "html", html: "<hr/><h4>Graduation</h4>" },
//             { type: "text", name: "graduation_college", title: "College/University", defaultValue: formData.graduation_college },
//             { type: "text", name: "graduation_branch", title: "Branch/Major", defaultValue: formData.graduation_branch, startWithNewLine: false },
//             { type: "text", name: "graduation_start_date", title: "Start Date", inputType: "date", defaultValue: formData.graduation_start_date },
//             { type: "text", name: "graduation_end_date", title: "End Date/Passing Year", inputType: "date", defaultValue: formData.graduation_end_date, startWithNewLine: false },
//             { type: "text", name: "graduation_percentage", title: "Percentage/GPA", inputType: "number", step: "0.01", defaultValue: formData.graduation_percentage },

//             // Post Graduation
//             { type: "html", html: "<hr/><h4>Post Graduation (If applicable)</h4>" },
//             { type: "text", name: "post_graduate_college", title: "College/University", defaultValue: formData.post_graduate_college },
//             { type: "text", name: "post_graduate_branch", title: "Branch/Specialization", defaultValue: formData.post_graduate_branch, startWithNewLine: false },
//             { type: "text", name: "post_graduate_start_date", title: "Start Date", inputType: "date", defaultValue: formData.post_graduate_start_date },
//             { type: "text", name: "post_graduate_end_date", title: "End Date/Passing Year", inputType: "date", defaultValue: formData.post_graduate_end_date, startWithNewLine: false },
//             { type: "text", name: "post_graduate_percentage", title: "Percentage/GPA", inputType: "number", step: "0.01", defaultValue: formData.post_graduate_percentage },

//             // Highest Degree
//             { type: "html", html: "<hr/><h4>Highest Degree</h4>" },
//             {
//               type: "dropdown", // Or text if more flexible input needed
//               name: "degree",
//               title: "Highest Degree Attained",
//               defaultValue: formData.degree,
//               choices: [ /* Add relevant degree choices */
//                 "High School", "Associate Degree", "Bachelor's Degree", "Master's Degree", "Doctorate (Ph.D.)", "Professional Degree (MD, JD, etc.)", "Vocational/Technical", "Other"
//               ],
//             },
//           ]
//         },
//         // --- Work Experience Section ---
//         {
//           type: "panel",
//           name: "work_experience",
//           title: "Current/Most Recent Work Experience",
//           elements: [
//             { type: "text", name: "current_comapny_name", title: "Company Name", defaultValue: formData.current_comapny_name },
//             { type: "text", name: "job_title", title: "Job Title/Position", defaultValue: formData.job_title, startWithNewLine: false },
//             { type: "comment", name: "current_company_address", title: "Company Address", rows: 3, defaultValue: formData.current_company_address },
//             { type: "text", name: "current_ctc", title: "Current CTC (Annual, in Rupees)", inputType: "number", step: "0.01", defaultValue: formData.current_ctc },
//             { type: "text", name: "gross", title: "Gross Salary (Monthly/Annual - Specify)", inputType: "number", step: "0.01", defaultValue: formData.gross, startWithNewLine: false },
//             { type: "text", name: "net", title: "Net Salary (Monthly/Annual - Specify)", inputType: "number", step: "0.01", defaultValue: formData.net },
//             { type: "text", name: "variables", title: "Variable Pay/Bonuses (if any)", inputType: "number", step: "0.01", defaultValue: formData.variables, startWithNewLine: false },
//             { type: "text", name: "current_notice_period_days", title: "Current Notice Period (days)", inputType: "number", min: 0, defaultValue: formData.current_notice_period_days },
//             { type: "comment", name: "reason_for_leaving", title: "Reason for Leaving (Optional)", rows: 3, defaultValue: formData.reason_for_leaving, startWithNewLine: false },
//           ],
//         },
//         // --- Total Experience ---
//         {
//           type: "panel",
//           name: "total_experience_panel",
//           title: "Total Work Experience",
//           elements: [
//             { type: "text", name: "Work_total_experience_year", title: "Years", inputType: "number", min: 0, defaultValue: formData.Work_total_experience_year },
//             { type: "text", name: "Work_total_experience_months", title: "Months", inputType: "number", min: 0, max: 11, defaultValue: formData.Work_total_experience_months, startWithNewLine: false },
//           ]
//         },
//         // --- Timezone ---
//         {
//           type: "dropdown",
//           name: "timezone",
//           title: "Time Zone",
//           isRequired: true,
//           // isRequired: true, // Make required if needed
//           defaultValue: formData.timezone,
//           choices: [ /* Add relevant timezone choices */
//             { value: "UTC", text: "Coordinated Universal Time (UTC)" },
//             { value: "GMT", text: "Greenwich Mean Time (GMT)" },
//             { value: "EST", text: "Eastern Standard Time (EST)" },
//             { value: "IST", text: "Indian Standard Time, IST" },
//             { value: "JST", text: "Japan Standard Time, JST" },
//             { value: "KST", text: "Korean Standard Time, KST" },
//             { value: "SST", text: "Singapore Standard Time, SST" },
//             { value: "MST", text: "Malaysia Standard Time, MST" },
//             { value: "CST", text: "China Standard Time, CST" },
//             { value: "PST", text: "Philippine Standard Time, PST" },
//             { value: "ICT", text: "Indochina Time, ICT" },
//             { value: "NPT", text: "Nepal Time, NPT" },
//             { value: "WIB", text: "Western Indonesia Time, WIB" },
//             { value: "HKT", text: "Hong Kong Standard Time, HKT" },
//             { value: "SLT", text: "Sri Lanka Time, SLT" },
//             { value: "GST", text: "Gulf Standard Time, GST)" },
//             { value: "PKT", text: "Pakistan Standard Time, PKT" }, // Corrected PST
//           ],
//         },
//       ],
//       showQuestionNumbers: false,
//       completeText: "Submit Profile",
//       widthMode: "static", // or responsive
//       width: "100%", // Adjust as needed
//       showCompletedPage: false,
//     };
//     const survey = new Model(surveyDefinition);

//     // --- Event Listeners & Configuration for the survey instance ---

//     // Re-apply the submit button logic when the model is created/recreated
//     survey.onAfterRenderSurvey.add((sender, options) => {
//       const completeButton = options.htmlElement.querySelector(".sd-btn--action"); // More reliable selector
//       if (completeButton) {
//         completeButton.disabled = isSubmitting;
//         completeButton.textContent = isSubmitting ? "Submitting..." : "Submit Profile"; // Use textContent
//       }
//     });

//     // Add other event listeners like onAfterRenderQuestion if needed
//     survey.onAfterRenderQuestion.add((sender, options) => {
//       // Example: Add specific validation or attributes dynamically
//       if (options.question.name === "current_notice_period_days") {
//         const input = options.htmlElement.querySelector("input");
//         if (input) {
//           input.type = "number";
//           input.min = "0";
//           // Add keypress listener if needed, but built-in number input handles much of it
//         }
//       }
//       // Add numeric input restriction for phone if needed (though regex validation is better)
//       if (options.question.name === "phone") {
//         const input = options.htmlElement.querySelector("input");
//         if (input) {
//           input.addEventListener("keydown", preventNonNumericInput); // Use keydown for better control
//         }
//       }
//     });

//     // Add the completion handler
//     survey.onComplete.add(handleSurveyCompletion);

//     return survey;
//   }

//   // Create or update the survey model when formData changes
//   useEffect(() => {
//     if (formData && Object.keys(formData).length > 0) { // Ensure formData has been populated
//       const newSurveyModel = createSurveyModel();
//       setSurveyModel(newSurveyModel);
//     }
//     // Cleanup function for event listeners if the component unmounts
//     // return () => {
//     //     if (surveyModel) {
//     //         // Remove listeners if necessary, though SurveyJS might handle some internally
//     //         surveyModel.onAfterRenderSurvey.clear();
//     //         surveyModel.onAfterRenderQuestion.clear();
//     //         surveyModel.onComplete.clear();
//     //     }
//     // };
//   }, [formData, isSubmitting]); // Recreate survey if formData or submission state changes


//   // Handles the actual submission logic
//   function handleSurveyCompletion(sender) {
//     setIsSubmitting(true);
//     setProgress(0); // Reset progress for upload indication
//     const surveyData = sender.data;
//     const userId = localStorage.getItem("user_id");

//     if (!userId) {
//       Swal.fire("Error!", "User session not found. Please log in again.", "error");
//       setIsSubmitting(false);
//       return;
//     }

//     const submissionFormData = new FormData();

//     // --- Resume Handling ---
//     // Check if a *new* resume file was selected
//     const newResumeUploaded = resumeFile instanceof File;

//     if (newResumeUploaded) {
//       submissionFormData.append("resume", resumeFile); // Append the new file
//     } else if (!resumePath) {
//       // No new file AND no existing path - Resume is mandatory
//       Swal.fire("Error!", "Please upload your resume.", "error");
//       setIsSubmitting(false);
//       return;
//     }
//     // If !newResumeUploaded && resumePath exists, we don't need to append anything for the resume.
//     // The backend will keep the existing one unless 'resume' key is present in the request FILES.

//     // Append survey data
//     Object.entries(surveyData).forEach(([key, value]) => {
//       // Handle cases where survey data might give null/undefined for non-answered optional fields
//       // Send empty string for blank fields, or omit if backend handles missing keys as no-update
//       if (value !== null && value !== undefined) {
//         submissionFormData.append(key, value);
//       } else {
//         submissionFormData.append(key, ""); // Send empty string for null/undefined
//       }
//     });

//     // Append user_id
//     submissionFormData.append("user_id", userId);

//     // --- API Call ---
//     const backendUrl = "https://raasbackend.vetrinahealthcare.com/update_applicant/"; // Ensure this matches your Django URL

//     axios
//       .post(backendUrl, submissionFormData, {
//         headers: {
//           "Content-Type": "multipart/form-data", // Crucial for file uploads
//         },
//         onUploadProgress: (progressEvent) => {
//           if (progressEvent.total) {
//             const calculatedProgress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
//             setProgress(calculatedProgress); // Update progress bar during upload
//           }
//         },
//       })
//       .then((response) => {
//         Swal.fire({
//           icon: "success",
//           title: "Success!",
//           text: response.data.message || "Your profile has been updated successfully.", // Use backend message
//           timer: 1500, // Slightly longer for user to read
//           timerProgressBar: true,
//           showConfirmButton: false,
//         }).then(() => {
//           navigate("/jobpostingresult"); // Navigate after success
//         });
//         console.log("Update Response:", response.data);
//       })
//       .catch((error) => {
//         console.error("Update Error:", error);
//         let errorMessage = "An error occurred while updating your profile.";
//         if (error.response && error.response.data) {
//           // Try to get specific errors from backend response
//           if (error.response.data.errors) {
//             // Format validation errors nicely
//             errorMessage = Object.entries(error.response.data.errors)
//               .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
//               .join("\n");
//           } else if (error.response.data.error_message) {
//             errorMessage = error.response.data.error_message;
//           }
//         }
//         Swal.fire({
//           icon: "error",
//           title: "Update Failed!",
//           text: errorMessage, // Show specific error
//           // timer: 3000, // Longer timer for errors
//           // timerProgressBar: true,
//           showConfirmButton: true, // Allow user to dismiss
//         });
//       })
//       .finally(() => {
//         setIsSubmitting(false); // Re-enable submit button
//         setProgress(0); // Reset progress bar after completion or error
//         // Optionally re-fetch data to ensure UI consistency, though navigation might handle this
//         // fetchData(formData.email);
//       });
//   }

//   // Handle manual resume file selection
//   function handleResume(e) {
//     const file = e.target.files[0];
//     if (file) {
//       if (file.type !== "application/pdf") {
//         Swal.fire("Invalid File Type", "Please upload a PDF file only.", "warning");
//         e.target.value = null; // Clear the input
//         return;
//       }
//       setResumeFile(file); // Store the actual file object
//       setResumePath(file.name); // Display the new file name

//       // --- Optional: Resume Parsing (Keep existing logic if needed) ---
//       const parsingFormData = new FormData();
//       parsingFormData.append("pdf_file", file);
//       parsingFormData.append("applicant_id", localStorage.getItem("user_id")); // Ensure user_id exists

//       axios.post("https://raasbackend.vetrinahealthcare.com/extract_text/", parsingFormData)
//         .then(response => {
//           const { data } = response;
//           // **Carefully** update form fields based on extracted data.
//           // Only update if the corresponding survey field is empty or if you want to override.
//           // It's often better *not* to overwrite user input from parsing.
//           // Example: Update only if fields are currently empty
//           setFormData(prevFormData => ({
//             ...prevFormData,
//             first_name: prevFormData.first_name || data.First_Name || "",
//             last_name: prevFormData.last_name || data.Last_Name || "",
//             phone: prevFormData.phone || data.phone_number || "",
//             // college: prevFormData.college || data.college_information || "", // Be cautious with education fields
//             // skills: prevFormData.skills || (data.skills ? data.skills.join(", ") : ""), // Handle skills carefully
//             // employer: prevFormData.employer || data.company || "", // Be cautious with work fields
//           }));
//           // Re-render the survey with potentially updated defaultValues
//           const newSurveyModel = createSurveyModel();
//           setSurveyModel(newSurveyModel);

//         })
//         .catch(error => {
//           console.error("Error extracting text from PDF:", error);
//           // Inform user if parsing fails, but don't block submission
//           // Swal.fire("Parsing Info", "Could not automatically parse resume details.", "info");
//         });
//     } else {
//       // No file selected or selection cancelled
//       setResumeFile(null);
//       // If there was an existing path, potentially revert display to it, or clear it
//       // Depends on desired UX - for now, let's keep the display potentially showing the old path
//       // You might need to re-fetch original data to get the old path back reliably if needed.
//       fetchData(formData.email); // Re-fetch to restore original resume path if selection is cancelled
//     }
//   }


//   return (
//     <>
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           height: "100vh",
//           overflowY: "hidden", // Prevent body scroll
//         }}
//       >
//         <DashNavbar />
//         <div style={{ display: "flex", flex: 1, overflowY: 'hidden' }}> {/* Prevent inner div scroll */}
//           <Sidebar />
//           {/* Make the main content area scrollable */}
//           <div className="container submitform" style={{ flex: 1, overflowY: 'auto', paddingBottom: '20px' }}>
//             <div className="" style={{ backgroundColor: "#f3f3f3", padding: "15px", borderRadius: "8px", marginBottom: "20px" }}>
//               {/* Progress Bar */}
//               <ProgressBar now={progress} label={`${progress.toFixed(0)}%`} className="my-3 mt-4">
//                 <ProgressBar
//                   striped
//                   variant={getColor(progress)}
//                   animated={progress < 100 && progress > 0} // Animate only during progress
//                   now={progress}
//                   label={`${progress.toFixed(0)}%`}
//                 />
//               </ProgressBar>

//               <h1 className="display-6 gradient-text mb-3">Profile Management</h1>
//               <p>Please fill out or update your profile details below. Fields marked with * are required.</p>
//               <hr />
//               {/* Resume Upload Section */}
//               <form className="m-auto w-75 mt-3" onSubmit={(e) => e.preventDefault()}> {/* Prevent default form submission */}
//                 <div>
//                   <label htmlFor="resumeInput" className="form-label fw-bold">
//                     Upload your resume <span className="text-danger">*</span> (PDF Only)
//                   </label>
//                   <input
//                     className="form-control form-control-lg"
//                     id="resumeInput" // Changed ID for clarity
//                     type="file"
//                     name="resume" // Name used if submitting via standard form, not strictly needed here
//                     accept=".pdf" // Enforce PDF
//                     onChange={handleResume}
//                   // Removed 'required' as validation is handled in handleSurveyCompletion
//                   />
//                   {/* Display existing path or new file name */}
//                   {resumePath && (
//                     <div className="mt-2 text-muted">
//                       Current Resume: {resumePath.split('/').pop()} {/* Show only filename */}
//                     </div>
//                   )}
//                 </div>
//               </form>
//             </div>

//             {/* Survey Section */}
//             <div style={{ flex: 1, backgroundColor: "#fff", padding: "15px", borderRadius: "8px" }}>
//               {surveyModel ? (
//                 <Survey model={surveyModel} />
//               ) : (
//                 <div className="text-center p-5"> <Spinner animation="border" /> Loading Profile Form...</div> // Show spinner while survey model loads
//               )}
//             </div>

//             {/* Loading Spinner during Submission */}
//             {isSubmitting && (
//               <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 9999 }}>
//                 <Spinner animation="border" variant="light" role="status">
//                   <span className="visually-hidden">Submitting...</span>
//                 </Spinner>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Jobapplication;










// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { Model } from "survey-core";
// import { Survey } from "survey-react-ui";
// import "survey-core/defaultV2.min.css";
// import "../css/index.css";
// import axios from "axios";
// import Swal from "sweetalert2";
// import DashNavbar from "../Misc/DashNavbar";
// import Sidebar from "../Misc/Sidebar";
// import ProgressBar from "react-bootstrap/ProgressBar";

// function getColor(progress) {
//   if (progress >= 0 && progress < 25) {
//     return "danger";
//   } else if (progress >= 25 && progress < 50) {
//     return "warning";
//   } else if (progress >= 50 && progress < 75) {
//     return "primary";
//   } else {
//     return "success";
//   }
// }

// function Jobapplication(props) {

//   const [resume, setResume] = useState(null);
//   const [resumePath, setResumePath] = useState("");
//   const [formData, setFormData] = useState({
//     email: "",
//     resume: "",
//   });
//   const [progress, setProgress] = useState(0);
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     const userEmail = localStorage.getItem("email");
//     if (userEmail) {
//       setFormData({ ...formData, email: userEmail });
//       fetchData(userEmail);
//     }
//   }, []);

//   async function fetchData(userEmail) {
//     try {
//       const userId = localStorage.getItem("user_id");
//       if (!userId) {
//         console.error("User ID not found in localStorage");
//         return;
//       }

//       const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicants/data/?user_id=${userId}`
//       );
//       const responseData = response.data[0];
//       const applicantFields = responseData.fields;
//       setFormData((prevState) => ({
//         ...prevState,
//         ...applicantFields,
//       }));
//       if (applicantFields.resume) {
//         setResumePath(applicantFields.resume);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   }

//   useEffect(() => {
//     updateProgress();
//   }, [formData]);

//   function updateProgress() {
//     console.log(formData);
//     // const totalQuestions = survey.getAllQuestions().length;
//     const answeredQuestions = Object.keys(formData).filter(
//       (key) => !!formData[key]
//     ).length;
//     const calculatedProgress = (answeredQuestions / 43) * 100;
//     setProgress(calculatedProgress);
//   }
//   function handleSurveyCompletion(sender, options) {
//     const surveyData = sender.data;
//     const userId = localStorage.getItem("user_id");

//     const emailform = surveyData.email;

//     const formData = new FormData();

//     const newResumeUploaded = !!resumeFile;

//     formData.append("resumePath", resumePath);

//     if (!newResumeUploaded && !resumePath) {
//       Swal.fire({
//         icon: "error",
//         title: "Error!",
//         text: "Please upload your resume.",
//         timer: 2000,
//         timerProgressBar: true,
//         showConfirmButton: false,
//       });
//       return;
//     }
//     if (newResumeUploaded) {
//       formData.append("resume", resumeFile);
//     }
//     Object.entries(surveyData).forEach(([key, value]) => {
//       formData.append(key, value);
//     });

//     formData.append("user_id", userId);

//     const backendUrl = "https://raasbackend.vetrinahealthcare.com/update_applicant/";

//     setIsLoading(true); // Start loading (show spinner)

//     axios
//       .post(backendUrl, formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//         onUploadProgress: (progressEvent) => {
//           const calculatedProgress = Math.round(
//             (progressEvent.loaded / progressEvent.total) * 100
//           );
//           setProgress(calculatedProgress);
//         },
//       })
//       .then((response) => {
//         Swal.fire({
//           icon: "success",
//           title: "Success!",
//           text: "Your job profile has been updated successfully.",
//           timer: 1000,
//           timerProgressBar: true,
//           showConfirmButton: false,
//         }).then(() => {
//           navigate("/jobpostingresult");
//         });
//         console.log("Response:", response.data);
//       })
//       .catch((error) => {
//         console.error("Error:", error);

//         Swal.fire({
//           icon: "error",
//           title: "Error!",
//           text: "An error occurred while updating your job profile. Please try again.",
//           timer: 1000,
//           timerProgressBar: true,
//           showConfirmButton: false,
//         });
//       })
//       .finally(() => {
//         setIsLoading(false); // Stop loading (hide spinner)
//       });
//   }

//   const survey = new Model({
//     elements: [
//       {
//         type: "panel",
//         name: "personal-info",
//         title: "Personal Information",
//         elements: [
//           {
//             type: "text",
//             name: "first_name",
//             title: "First name",
//             defaultValue: formData.first_name,
//             isRequired: true,
//           },
//           {
//             type: "text",
//             name: "last_name",
//             startWithNewLine: false,
//             title: "Last name",
//             defaultValue: formData.last_name,
//             isRequired: true,
//           },

//           {
//             type: "text",
//             name: "email",
//             title: "Email",
//             inputType: "email",
//             placeholder: "mail@example.com",
//             defaultValue: formData.email,
//             // readOnly: true,
//             isRequired: true,
//           },

//           {
//             type: "panel",
//             name: "phone-panel",
//             elements: [
//               {
//                 type: "dropdown",
//                 name: "country_code",
//                 title: "Country Code",
//                 defaultValue: formData.country_code || "+91",
//                 choices: [
//                   { value: "+1", text: "+1" },
//                   { value: "+44", text: "+44" },
//                   { value: "+91", text: "+91" },
//                   { value: "+81", text: "+81" },
//                   { value: "+86", text: "+86" },
//                   // Add more country codes as needed
//                 ],
//                 startWithNewLine: false,
//                 colCount: 0,
//               },
//               {
//                 type: "text",
//                 name: "phone",
//                 title: "Phone Number",
//                 inputType: "tel",
//                 placeholder: "Enter 10-digit phone number",
//                 defaultValue: formData.phone ? formData.phone.toString() : "",
//                 isRequired: true,
//                 startWithNewLine: false,
//                 colCount: 0,
//               },
//             ],
//             colCount: 2,
//           },
//         ],
//       },
//       {
//         type: "panel",
//         name: "location",
//         title: "Addresses",

//         elements: [
//           {
//             type: "dropdown",
//             name: "address_type",
//             title: "Type of Address",
//             defaultValue: formData.address_type,
//             choices: [
//               {
//                 value: "home",
//                 text: "Home",
//               },
//               {
//                 value: "other",
//                 text: "Other",
//               },
//             ],
//           },
//           {
//             type: "text",
//             name: "street_address",
//             title: "Street Address",
//             startWithNewLine: false,
//             defaultValue: formData.street_address,
//             inputClass: "sv_q_inline",
//           },
//           {
//             type: "text",
//             name: "city",
//             title: "City",
//             defaultValue: formData.city,
//           },
//           {
//             type: "dropdown",
//             name: "country",
//             title: "Country",
//             defaultValue: formData.country,
//             choicesByUrl: {
//               url: "https://surveyjs.io/api/CountriesExample",
//             },
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//           },
//           {
//             type: "text",
//             name: "state",
//             title: "State",
//             defaultValue: formData.state,
//             choices: [
//               "Andhra Pradesh",
//               "Arunachal Pradesh",
//               "Assam",
//               "Bihar",
//               "Chhattisgarh",
//               "Goa",
//               "Gujarat",
//               "Haryana",
//               "Himachal Pradesh",
//               "Jharkhand",
//               "Karnataka",
//               "Kerala",
//               "Madhya Pradesh",
//               "Maharashtra",
//               "Manipur",
//               "Meghalaya",
//               "Mizoram",
//               "Nagaland",
//               "Odisha",
//               "Punjab",
//               "Rajasthan",
//               "Sikkim",
//               "Tamil Nadu",
//               "Telangana",
//               "Tripura",
//               "Uttar Pradesh",
//               "Uttarakhand",
//               "West Bengal",
//             ],
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//           },

//           {
//             type: "text",
//             name: "zip_code",
//             startWithNewLine: false,
//             title: "Zip code",
//             inputType: "number",
//             defaultValue: formData.zip_code,
//             validators: [
//               {
//                 type: "numeric",
//               },
//             ],
//           },
//         ],
//       },

//       {
//         type: "panel",
//         elements: [
//           {
//             type: "dropdown",
//             name: "relocating",
//             title: "Are you open to relocating to Job Location?",
//             defaultValue: formData.relocating,
//             choices: [
//               {
//                 value: "yes",
//                 text: "Yes",
//               },
//               {
//                 value: "no",
//                 text: "No",
//               },
//             ],
//           },
//           {
//             type: "dropdown",
//             name: "employed_with_datetech",
//             title:
//               "Have you ever been employed with our organization?",
//             defaultValue: formData.employed_with_datetech,
//             choices: [
//               {
//                 value: "yes",
//                 text: "Yes",
//               },
//               {
//                 value: "no",
//                 text: "No",
//               },
//             ],
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//           },

//           {
//             type: "text",
//             name: "employee_id",
//             title: "If yes, please provide your Employee ID. If no, enter N/A",
//             defaultValue: formData.employee_id,
//           },
//           {
//             type: "text",
//             name: "birthdate",
//             title: "Date of birth",
//             inputType: "date",
//             defaultValue: formData.birthdate,
//             isRequired: true,
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//           },
//           {
//             type: "dropdown",
//             name: "employed_with_govt",
//             title:
//               "Are you currently employed with government or government agency in any capacity or were employed in the last 12 months ? ",
//             defaultValue: formData.employed_with_govt,
//             choices: [
//               {
//                 value: "yes",
//                 text: "Yes",
//               },
//               {
//                 value: "no",
//                 text: "No",
//               },
//             ],
//           },

//           {
//             type: "dropdown",
//             name: "how_did_you_hear",
//             title: "How did you hear about us?",
//             defaultValue: formData.how_did_you_hear,
//             choices: [
//               {
//                 value: "alumni",
//                 text: "Alumni",
//               },
//               {
//                 value: "website",
//                 text: "Company Website",
//               },
//               {
//                 value: "conversion",
//                 text: "Conversion",
//               },
//               {
//                 value: "source",
//                 text: "Direct Source",
//               },
//               {
//                 value: "govt",
//                 text: "Government",
//               },
//               {
//                 value: "jobboard",
//                 text: "Job Board",
//               },
//               {
//                 value: "socialmedia",
//                 text: "Social Media",
//               },
//               {
//                 value: "other",
//                 text: "Other",
//               },
//             ],
//           },
//           {
//             type: "text",
//             name: "specify_hear",
//             title: "Please specify further",
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//             defaultValue: formData.specify_hear,
//           },
//         ],
//       },

//       {
//         type: "panel",
//         name: "education_info",
//         title: "Education",

//         elements: [
//           {
//             type: "dropdown",
//             name: "degree",
//             title: "Degree",
//             defaultValue: formData.degree,
//             choices: [
//               "Bachelor's Degree",
//               "AI&ML",
//               "Data Science",
//               "Master's Degree",
//               "Ph.D.",
//               "Associate Degree",
//               "High School Diploma",
//               "Vocational/Technical Degree",
//               "Professional Certification",
//               "Doctor of Medicine (MD)",
//               "Doctor of Dental Surgery (DDS)",
//               "Juris Doctor (JD)",
//               "Bachelor of Science in Engineering",
//               "Bachelor of Arts",
//               "Bachelor of Fine Arts",
//               "Bachelor of Business Administration",
//               "Bachelor of Computer Science",
//               "Master of Science",
//               "Master of Business Administration",
//               "Master of Arts",
//               "Doctor of Philosophy (Ph.D.) in [Your Field]",
//               "Other",
//             ],
//             isRequired: true,
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//           },
//           {
//             type: "text",
//             name: "specify_degree",
//             title: "Please specify further",
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//             placeHolder: "Enter other degree here",
//             defaultValue: formData.specify_degree,
//           },

//           {
//             type: "text",
//             name: "college",
//             title: "College/University",
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//             defaultValue: formData.college,
//             isRequired: true,
//           },
//           {
//             type: "dropdown",
//             name: "branch",
//             title: "Branch of Study",
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//             defaultValue: formData.branch,
//             isRequired: true,
//             choices: [
//               "Computer Science",
//               "Electrical Engineering",
//               "Mechanical Engineering",
//               "Civil Engineering",
//               "Chemical Engineering",
//               "Biomedical Engineering",
//               "Mathematics",
//               "Physics",
//               "Chemistry",
//               "Biology",
//               "Economics",
//               "Psychology",
//               "Sociology",
//               "Other",
//             ],
//           },
//           {
//             type: "text",
//             name: "graduation_date",
//             title: "Graduation Date / Year of Passing ",
//             isRequired: true,
//             inputType: "date",
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//             defaultValue: formData.graduation_date,
//           },

//           {
//             type: "dropdown",
//             name: "country_of_college",
//             title: "Country",
//             defaultValue: formData.country_of_college,
//             choicesByUrl: {
//               url: "https://surveyjs.io/api/CountriesExample",
//             },
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//             isRequired: true,
//           },
//           {
//             type: "text",
//             name: "city_of_college",
//             title: "City/Town",
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//             isRequired: true,
//             defaultValue: formData.city_of_college,
//           },
//           {
//             type: "text",
//             name: "state_of_college",
//             title: "State",
//             isRequired: true,
//             choices: [
//               "Andhra Pradesh",
//               "Arunachal Pradesh",
//               "Assam",
//               "Bihar",
//               "Chhattisgarh",
//               "Goa",
//               "Gujarat",
//               "Haryana",
//               "Himachal Pradesh",
//               "Jharkhand",
//               "Karnataka",
//               "Kerala",
//               "Madhya Pradesh",
//               "Maharashtra",
//               "Manipur",
//               "Meghalaya",
//               "Mizoram",
//               "Nagaland",
//               "Odisha",
//               "Punjab",
//               "Rajasthan",
//               "Sikkim",
//               "Tamil Nadu",
//               "Telangana",
//               "Tripura",
//               "Uttar Pradesh",
//               "Uttarakhand",
//               "West Bengal",
//             ],
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//             defaultValue: formData.state_of_college,
//           },
//         ],
//       },

//       {
//         type: "dropdown",
//         name: "nationality",
//         title: "Nationality",
//         isRequired: true,
//         defaultValue: formData.nationality,
//         choices: [
//           "American",
//           "British",
//           "Canadian",
//           "Australian",
//           "French",
//           "German",
//           "Italian",
//           "Spanish",
//           "Chinese",
//           "Indian",
//           "Japanese",
//           "Brazilian",
//           "Mexican",
//           "Russian",
//           "South African",
//         ],
//       },
//       {
//         type: "dropdown",
//         name: "authorized_to_work",
//         isRequired: true,
//         title: "Are you legally authorized to work in the country?",
//         choices: [
//           {
//             value: "yes",
//             text: "Yes",
//           },
//           {
//             value: "no",
//             text: "No",
//           },
//         ],
//         startWithNewLine: false,
//         inputClass: "sv_q_inline",
//         defaultValue: formData.authorized_to_work,
//       },

//       {
//         type: "dropdown",
//         name: "require_visa_sponsorship",
//         title:
//           "Will you now or in future require the company’s sponsorship for employment Visa (H1-B,TN,EAD,other work visa)?",
//         choices: [
//           {
//             value: "yes",
//             text: "Yes",
//           },
//           {
//             value: "no",
//             text: "No",
//           },
//         ],
//         defaultValue: formData.require_visa_sponsorship,
//       },

//       {
//         type: "panel",
//         name: "work_experience",
//         title: "Work Experience",
//         elements: [
//           {
//             type: "text",
//             name: "employer",
//             title: "Employer",
//             defaultValue: formData.employer,
//           },
//           {
//             type: "text",
//             name: "work_city",
//             title: "City/Town",
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//             defaultValue: formData.work_city,
//           },
//           {
//             type: "dropdown",
//             name: "work_country",
//             title: "Country",
//             choicesByUrl: {
//               url: "https://surveyjs.io/api/CountriesExample",
//             },
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//             defaultValue: formData.work_country,
//           },
//           {
//             type: "text",
//             name: "work_state",
//             title: "State",
//             choices: [
//               "Andhra Pradesh",
//               "Arunachal Pradesh",
//               "Assam",
//               "Bihar",
//               "Chhattisgarh",
//               "Goa",
//               "Gujarat",
//               "Haryana",
//               "Himachal Pradesh",
//               "Jharkhand",
//               "Karnataka",
//               "Kerala",
//               "Madhya Pradesh",
//               "Maharashtra",
//               "Manipur",
//               "Meghalaya",
//               "Mizoram",
//               "Nagaland",
//               "Odisha",
//               "Punjab",
//               "Rajasthan",
//               "Sikkim",
//               "Tamil Nadu",
//               "Telangana",
//               "Tripura",
//               "Uttar Pradesh",
//               "Uttarakhand",
//               "West Bengal",
//             ],
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//             defaultValue: formData.work_state,
//           },
//           {
//             type: "text",
//             name: "job_title",
//             title: "Job Title",
//             defaultValue: formData.job_title,
//           },
//           {
//             type: "text",
//             name: "work_start_date",
//             title: "Start Date",
//             inputType: "date",
//             defaultValue: formData.work_start_date,
//           },
//           {
//             type: "text",
//             name: "work_end_date",
//             title: "End Date",
//             inputType: "date",
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//             defaultValue: formData.work_end_date,
//           },
//           {
//             type: "text",
//             name: "work_description",
//             title: "Description",
//             inputType: "textarea",
//             defaultValue: formData.work_description,
//             cols: 30,
//             rows: 5,
//           },
//           {
//             type: "text",
//             name: "reason_for_leaving",
//             title: "Reason for Leaving",
//             inputType: "textarea",
//             defaultValue: formData.reason_for_leaving,
//             cols: 30,
//             rows: 5,
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//           },
//         ],
//       },

//       {
//         type: "panel",
//         elements: [
//           {
//             type: "text",
//             name: "current_ctc",
//             title: "Current CTC (in Rupee)",
//             inputType: "number",
//             validators: [
//               {
//                 type: "numeric",
//               },
//             ],
//             defaultValue: formData.current_ctc,
//           },
//           {
//             type: "text",
//             name: "total_experience_months",
//             title: "Total Experience  (in months)",
//             inputType: "number",
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//             defaultValue: formData.total_experience_months,
//           },
//           {
//             type: "text",
//             name: "current_notice_period_days",
//             title: "Current Notice Period (days)",
//             inputType: "number",
//             defaultValue: formData.current_notice_period_days,
//           },
//           {
//             type: "text",
//             name: "skills",
//             title: "Skills",
//             inputType: "text",
//             startWithNewLine: false,
//             inputClass: "sv_q_inline",
//             defaultValue: formData.skills,
//           },
//         ],
//       },

//       {
//         type: "dropdown",
//         name: "timezone",
//         title: "Time Zone",
//         isRequired: true,
//         defaultValue: formData.timezone,
//         choices: [
//           { value: "UTC", text: "Coordinated Universal Time (UTC)" },
//           { value: "GMT", text: "Greenwich Mean Time (GMT)" },
//           { value: "EST", text: "Eastern Standard Time (EST)" },
//           { value: "IST", text: "Indian Standard Time, IST" },
//           { value: "JST", text: "Japan Standard Time, JST" },
//           { value: "KST", text: "Korean Standard Time, KST" },
//           { value: "SST", text: "Singapore Standard Time, SST" },
//           { value: "MST", text: "Malaysia Standard Time, MST" },
//           { value: "CST", text: "China Standard Time, CST" },
//           { value: "PST", text: "Philippine Standard Time, PST" },
//           { value: "ICT", text: "Indochina Time, ICT" },
//           { value: "NPT", text: "Nepal Time, NPT" },
//           { value: "WIB", text: "Western Indonesia Time, WIB" },
//           { value: "HKT", text: "Hong Kong Standard Time, HKT" },
//           { value: "SLT", text: "Sri Lanka Time, SLT" },
//           { value: "GST", text: "Gulf Standard Time, GST)" },
//           { value: "PST", text: "Pakistan Standard Time, PST" },
//         ],
//       },
//     ],

//     onUploadFiles: (sender, options) => {
//       if (options.name === "resume") {
//         setResume(options.files[0]);
//       }
//     },

//     showQuestionNumbers: false,
//     completeText: "Submit Profile",
//     widthMode: "static",
//     width: "1000px",
//     showCompletedPage: false,
//   });

//   survey.onComplete.add(handleSurveyCompletion);

//   function handleInputChange(event) {
//     const { name, value } = event.target;
//     setFormData({ ...formData, [name]: value });
//   }

//   let [resumeFile, setResumeFile] = useState("");

//   function handleResume(e) {
//     let filePath = e.target.files[0];
//     if (filePath) {
//       setResumeFile(filePath);
//       const formData = new FormData();
//       formData.append("pdf_file", filePath);
//       formData.append("applicant_id", localStorage.getItem("user_id")); // Add the applicant_id to the form data

//       axios
//         .post("https://raasbackend.vetrinahealthcare.com/extract_text/", formData)
//         .then((response) => {
//           const { data } = response;
//           // Update the form data with the extracted values
//           setFormData((prevFormData) => ({
//             ...prevFormData,
//             first_name: data.First_Name || '',
//             last_name: data.Last_Name || '',
//             phone: data.phone_number || '',
//             college: data.college_information || '',
//             skills: data.skills.join(", ") || '',
//             employer: data.company || "",
//             // Add more fields as needed
//           }));
//         })
//         .catch((error) => {
//           console.error("Error extracting text from PDF:", error);
//         });
//     }
//   }

//   return (
//     <>
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           height: "100vh",
//           overflowY: "hidden",
//         }}
//       >
//         <DashNavbar />
//         <div style={{ display: "flex", flex: 1 }}>
//           <Sidebar />
//           <div className="container  submitform  ">
//             <div style={{ overflow: "auto", height: "92.5vh" }}>
//               <div className="" style={{ backgroundColor: "#f3f3f3" }}>
//                 <ProgressBar
//                   animated
//                   now={progress}
//                   label={`${progress.toFixed(2)}%`}
//                   className="my-3 mt-4"
//                 >
//                   <ProgressBar
//                     striped
//                     variant={getColor(progress)}
//                     animated
//                     now={progress}
//                     label={`${progress.toFixed(2)}%`}
//                   />
//                 </ProgressBar>{" "}
//                 <h1 className="display-6 gradient-text mb-3">
//                   Profile Management
//                 </h1>
//                 <hr />
//                 <form className="m-auto w-50 mt-3">
//                   <div>
//                     <label for="formFileLg" className="form-label">
//                       Upload your resume <span className="text-danger">*</span>
//                     </label>
//                     <input
//                       className="form-control form-control-lg"
//                       id="fileInput"
//                       type="file"
//                       name="resume"
//                       accept=".pdf"
//                       onChange={handleResume}
//                       required
//                     />
//                     {resumePath && (
//                       <input
//                         className="form-control form-control-sm mt-2"
//                         type="text"
//                         value={resumePath}
//                         readOnly
//                       />
//                     )}
//                   </div>
//                 </form>
//               </div>
//               <div style={{ flex: 1 }}>
//                 <Survey model={survey} />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Jobapplication;
